// extracted by mini-css-extract-plugin
export default {"quickLinks":"home_quickLinks__JIozC"};